'use client'

import type { Data } from '@repo/strapi'
import { useParams } from 'next/navigation'
import { useTranslations } from 'next-intl'
import AppLink from '@/components/elementary/AppLink'
import { Container } from '@/components/elementary/Container'
import { Paragraph } from '@/components/typography/Paragraph'
import { ROOT_BLOG_PAGE_PATH } from '@/lib/constants'
import { cn } from '@/lib/styles'
import { BLOG_NAVIGATION_TEST_IDS } from '@/lib/test-ids'
import { getBlogCategoryLink } from '@/utils/links'

export function BlogNavigation({
	categories,
}: {
	categories: Data.ContentType<'api::blog-category.blog-category'>[]
}) {
	const t = useTranslations('BlogNavigation')
	const params = useParams()
	const selectedCategory = params.slug

	return (
		<Container
			className="lg:block hidden pb-10 pt-4"
			data-test-id={BLOG_NAVIGATION_TEST_IDS.COMPONENT}
			paddingX
		>
			<ul className="flex flex-wrap gap-10 items-center border-b border-brand-black">
				<li className="border-b-2 border-transparent">
					<AppLink
						href={ROOT_BLOG_PAGE_PATH}
						size="none"
						variant="secondaryLink"
						className="group"
						data-test-id={BLOG_NAVIGATION_TEST_IDS.BLOG_LINK}
					>
						<Paragraph
							fontSize="bodyRegularMedium"
							className="group-hover:text-peach-600 transition-colors duration-300"
						>
							{t('title')}
						</Paragraph>
					</AppLink>
				</li>

				{categories?.map((category) => {
					if (!category.slug) return null
					return (
						<li
							key={category.documentId}
							className={cn(
								'border-b-2 border-transparent',
								category.slug === selectedCategory && 'border-brand-black',
							)}
						>
							<AppLink
								href={getBlogCategoryLink(category.slug)}
								size="none"
								variant="secondaryLink"
								className={cn('group', category.slug === selectedCategory && 'font-bold')}
								data-test-id={BLOG_NAVIGATION_TEST_IDS.CATEGORY_LINK}
							>
								<Paragraph
									fontSize="bodyRegularMedium"
									className="group-hover:text-peach-600 transition-colors duration-300"
								>
									{category.name}
								</Paragraph>
							</AppLink>
						</li>
					)
				})}
			</ul>
		</Container>
	)
}
